<script>
  import { onMount } from 'svelte';
  import ConversationListMobile from './ConversationListMobile.svelte';
  import ChatContentMobile from './ChatContentMobile.svelte';
  import { persist } from '$lib/stores/face-store';
  import { conversationId, conversations, loadMessagesWS, messages } from '$lib/websocket-client.js';

  const chatScreen = persist('chatScreen', 'list');
  const activeChat = persist('activeChat', null);
  const lastConversationId = persist('mobile:lastConversationId', null);
  let allowListRestore = true;
  let hydratedOnce = false;

  function openChat(chat) {
    if (!chat?.conversationId) return;

    const isSameConversation = String($conversationId ?? '') === String(chat.conversationId);
    activeChat.set(chat);
    lastConversationId.set(chat.conversationId);
    conversationId.set(chat.conversationId);
    if (!isSameConversation) messages.set([]);
    if (!isSameConversation || !$messages.length) loadMessagesWS(chat.conversationId);
    chatScreen.set('detail');
    hydratedOnce = true;
  }

  export function back() {
    allowListRestore = false;
    chatScreen.set('list');
  }

  function restoreConversationFromState() {
    const restoredId = $activeChat?.conversationId || $lastConversationId;

    if (!restoredId) {
      return;
    }

    if (String($conversationId ?? '') !== String(restoredId)) {
      conversationId.set(restoredId);

      const restoredConversation = ($conversations || []).find(
        (item) => String(item.conversationId) === String(restoredId)
      );

      if (restoredConversation && String($activeChat?.conversationId ?? '') !== String(restoredConversation.conversationId)) {
        activeChat.set(restoredConversation);
      }

      loadMessagesWS(restoredId);
    } else if (!$messages.length) {
      loadMessagesWS(restoredId);
    }
  }

  onMount(() => {
    restoreConversationFromState();
    hydratedOnce = true;
  });

  $: if ($chatScreen === 'detail' || (!hydratedOnce && allowListRestore)) {
    restoreConversationFromState();
  }
</script>

{#if $chatScreen === 'list'}
  <ConversationListMobile {openChat} {allowListRestore} />
{:else if $chatScreen === 'detail'}
  <ChatContentMobile activeChat={$activeChat} {back} />
{/if}
